/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Templates_SyncedInputs */

const vi_einvoice_templates_synced = /** @type {(inputs: Einvoice_Templates_SyncedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đồng bộ mẫu hóa đơn từ MISA`)
};

/**

* @param {Einvoice_Templates_SyncedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_templates_synced = /** @type {((inputs?: Einvoice_Templates_SyncedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Templates_SyncedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_templates_synced(inputs)
});